/**
 * Token persistence — kept byte-compatible with legacy main.js so the same
 * device can roam between the H5 site and the React app without re-logging.
 *
 * Legacy reference: main.js §3 (lines 89–463), `apiState.token`.
 */

import { STORAGE_KEYS } from "../storage/keys.js";
import { readStorageItem, removeStorageItem, writeStorageItem } from "../storage/localStorage.js";

export const DEV_AUTO_LOGIN_ACCOUNT = {
  username: "me",
  password: "password123",
} as const;

export function readStoredToken(): string | null {
  const raw = readStorageItem(STORAGE_KEYS.apiToken);
  if (!raw) return null;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function storeToken(token: string | null): void {
  if (!token) {
    removeStorageItem(STORAGE_KEYS.apiToken);
    return;
  }
  writeStorageItem(STORAGE_KEYS.apiToken, token);
  removeStorageItem(STORAGE_KEYS.devLogout);
}

export function clearStoredToken(): void {
  removeStorageItem(STORAGE_KEYS.apiToken);
}

export function suppressDevAutoLogin(): void {
  if (!isLocalDevHost()) return;
  writeStorageItem(STORAGE_KEYS.devLogout, "1");
}

export function isDevAutoLoginSuppressed(): boolean {
  return readStorageItem(STORAGE_KEYS.devLogout) === "1";
}

export function isLocalDevHost(hostname = window.location.hostname): boolean {
  return ["localhost", "127.0.0.1", ""].includes(hostname);
}

export function isDevAutoLoginEnabled(value = import.meta.env.VITE_DEV_AUTOLOGIN): boolean {
  return String(value || "").toLowerCase() === "true";
}

export function shouldAttemptDevAutoLogin(
  hostname = window.location.hostname,
  enabled = import.meta.env.VITE_DEV_AUTOLOGIN,
): boolean {
  return isLocalDevHost(hostname) && isDevAutoLoginEnabled(enabled) && !isDevAutoLoginSuppressed();
}
